<!--The content below is only a placeholder and can be replaced.-->
@if (features().showHeader) {
  <app-header></app-header>
}
<main [attr.aria-label]="application().ariaLabel">
  <router-outlet></router-outlet>
</main>
@if (features().showFooter) {
  <app-footer></app-footer>
}
<app-loader></app-loader>
<app-modal></app-modal>
<app-connect-modal></app-connect-modal>